import { render } from "./IctGuideline.vue?vue&type=template&id=4ee50d90&scoped=true"
import script from "./IctGuideline.vue?vue&type=script&lang=js"
export * from "./IctGuideline.vue?vue&type=script&lang=js"

import "./IctGuideline.vue?vue&type=style&index=0&id=4ee50d90&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee50d90"]])

export default __exports__